import React from 'react';
import Typography from '../common/Typography';

/**
 * Hall-phone notice while Offline mode is on. Stays up until End session.
 */
const OfflineSaveBanner = ({
  pendingCount = 0,
  isFlushing = false,
  hallMode = false,
}) => {
  if (!hallMode && !pendingCount) return null;

  const pendingBody = isFlushing
    ? `Saving ${pendingCount} change${pendingCount === 1 ? '' : 's'}… You can’t end the session until these games upload.`
    : pendingCount
      ? `${pendingCount} change${pendingCount === 1 ? '' : 's'} ${pendingCount === 1 ? 'is' : 'are'} on this phone. Connect to wifi so they can upload — End session unlocks when saving finishes.`
      : 'This phone is running the session. Players cannot follow courts on their phones.';

  return (
    <div
      role="status"
      className="sticky top-0 z-40 flex flex-wrap items-center justify-between gap-3 border-b-2 border-warning bg-warning-light px-4 py-2.5 text-warning-dark shadow-sm dark:bg-warning/25"
    >
      <div className="min-w-0">
        <Typography variant="body" className="font-semibold text-warning-dark">
          Offline mode
        </Typography>
        <Typography variant="caption" className="text-warning-dark">
          {pendingBody}
        </Typography>
      </div>
    </div>
  );
};

export default OfflineSaveBanner;
